import StockTransactionAuditPage from "./StockTransactionAuditPage";

export {StockTransactionAuditPage}
export default StockTransactionAuditPage
